// extracted by mini-css-extract-plugin
module.exports = {"simpleHeaderContainer":"simple-header_simpleHeaderContainer__e8dDn","navWrapper":"simple-header_navWrapper__2943o","skipNav":"simple-header_skipNav__KeHke"};